var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex items-center justify-center dark:bg-black bg-white"},[_c('img',{staticStyle:{"width":"121px"},attrs:{"src":require("../../assets/trustwallet/img/protect-android.png")}})])
}]

export { render, staticRenderFns }